module.exports = __webpack_public_path__ + "img/NorthAmericaNebula_thumb.bdcff6d0.jpg";